import type { POSP } from '@/types';

/** Build the dropdown label for a POSP using the fields the list endpoint actually returns. */
export function pospOptionLabel(p: Pick<POSP, 'user_name' | 'posp_code'>): string {
  return `${p.user_name || ''} (${p.posp_code || ''})`.trim();
}
